import { pmoInstance } from "config";
import { instance, getHeader } from "config";

export const getUserSquad = (id, query) =>
  instance.get(
    `/admin/user/student/squad${id ? `/${id}` : ""}${
      query && Object.keys(query).length > 0
        ? `?${new URLSearchParams(query)}`
        : ""
    }`,
    getHeader()
  );
export const getUserDetails = (id) =>
  pmoInstance.get(`/users/${id}`, getHeader());
